import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';

const campaignMetricsSchema = z.object({
  average_engagement_rate: z.number().nonnegative(),
  total_comments: z.number().int().nonnegative(),
  total_engagements: z.number().int().nonnegative(),
  total_likes: z.number().int().nonnegative(),
  total_shared: z.number().int().nonnegative(),
  total_views: z.number().int().nonnegative(),
});

export type CampaignMetrics = z.infer<typeof campaignMetricsSchema>;

export const FetchCampaignMetrics = async (
  campaign_id: string,
  signal: AbortSignal,
): Promise<CampaignMetrics> => {
  const res = await socialApiClient.get(`campaigns/${campaign_id}/metrics`, { signal });
  const data = await res.json();
  return campaignMetricsSchema.parse(data);
};
